/* FWC product enquiry form — variant sync
   Keeps the hidden contact[Variant] field in step with the variant picker so a
   quote request records the exact lease term or purchase option the customer was
   viewing, even if they never reload the page.

   Uses delegated listeners rather than Dawn's pubsub so it is independent of
   script load order and survives Dawn re-rendering variant-selects — the same
   approach as fwc-accessory-variant-sync.js. */
(() => {
  function getSelectedOptionValues() {
    const picker = document.querySelector("variant-selects");
    if (!picker) return [];

    const values = [];

    picker.querySelectorAll("select[name^='options[']").forEach((select) => {
      if (select.value) values.push(select.value);
    });

    picker.querySelectorAll("input[type='radio']:checked").forEach((radio) => {
      if (radio.value) values.push(radio.value);
    });

    return values;
  }

  function syncVariantFields() {
    const fields = document.querySelectorAll(".fwc-enquiry__variant");
    if (!fields.length) return;

    const values = getSelectedOptionValues();
    // No picker on a single-variant product — leave the server-rendered value alone.
    if (!values.length) return;

    const title = values.join(" / ");
    fields.forEach((field) => {
      field.value = title;
    });
  }

  /* After the post-submit page load the browser lands at the top of the product
     page, leaving the confirmation well below the fold. Bring it into view so the
     customer actually sees that the enquiry was sent.

     This has to wait for `load` rather than run on `defer`: the product page pulls
     in gallery imagery below this block, and the resulting layout shift cancels any
     scroll performed earlier. An instant scroll is used for the same reason — a
     smooth animation is interrupted by that shift. */
  function revealSubmissionResult() {
    const result = document.querySelector(".fwc-enquiry__success, .fwc-enquiry__error");
    if (!result) return;

    const details = result.closest(".fwc-enquiry")?.querySelector("details");
    if (details) details.open = true;

    const reveal = () => {
      result.scrollIntoView({ block: "center" });
      result.focus({ preventScroll: true });
    };

    if (document.readyState === "complete") {
      setTimeout(reveal, 100);
    } else {
      window.addEventListener("load", () => setTimeout(reveal, 100), { once: true });
    }
  }

  function bind() {
    syncVariantFields();
    revealSubmissionResult();

    document.addEventListener("change", (e) => {
      if (e.target.closest("variant-selects")) syncVariantFields();
    });

    document.addEventListener("variant:change", syncVariantFields);
    document.addEventListener("variantChange", syncVariantFields);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();
